import { useEffect, useState } from "react";
import { ReferralData } from "../menu.types";

declare global {
  interface Window {
    EventManager?: any;
  }
}

export const useReferral = ({
  initialReferral,
}: {
  initialReferral?: ReferralData;
}) => {
  const [referral, setReferral] = useState<ReferralData>(
    initialReferral as ReferralData,
  );

  useEffect(() => {
    if (!window.EventManager) return;

    window.EventManager.addHandler(
      "update:menu:referral",
      (data: ReferralData) => {
        setReferral(data);
      },
    );
  }, []);

  return referral;
};
